const investorInfoReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_INVESTOR_INFO":
          return state;
      case "SET_INVESTOR_INFO" :
          return action.info;
      case "NULL_INVESTOR_INFO" :
          return action.info;
      default:
          return state;
    }
  }
  export default investorInfoReducer